/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Org
 */
export interface Org {
    /**
     * 
     * @type {string}
     * @memberof Org
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof Org
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Org
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof Org
     */
    id: string;
}

/**
 * Check if a given object implements the Org interface.
 */
export function instanceOfOrg(value: object): value is Org {
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function OrgFromJSON(json: any): Org {
    return OrgFromJSONTyped(json, false);
}

export function OrgFromJSONTyped(json: any, ignoreDiscriminator: boolean): Org {
    if (json == null) {
        return json;
    }
    return {
        
        'displayName': json['displayName'],
        'name': json['name'],
        'customerId': json['customerId'],
        'id': json['id'],
    };
}

export function OrgToJSON(value?: Org | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'displayName': value['displayName'],
        'name': value['name'],
        'customerId': value['customerId'],
        'id': value['id'],
    };
}

